import { useState } from "react";
import { Phone, Menu, X, Lock } from "lucide-react";
import { Logo } from "./Logo";
import { scrollToSection } from "../lib/scroll";
import { NAV_LINKS } from "../lib/navLinks";

const DesktopActions = ({ go }) => (
  <div className="hidden items-center gap-3 md:flex">
    <a data-testid="nav-phone-link" href="tel:+33784678802" className="flex items-center gap-2 rounded-full border border-navy/15 px-4 py-2 text-sm font-semibold text-navy transition-colors hover:border-gold hover:text-gold-dark">
      <Phone size={15} strokeWidth={2.2} /> 07 84 67 88 02
    </a>
    <a data-testid="nav-admin-link" href="/admin" aria-label="Espace propriétaire" title="Espace propriétaire" className="flex h-9 w-9 items-center justify-center rounded-full border border-navy/15 text-navy transition-colors hover:border-gold hover:text-gold-dark">
      <Lock size={14} strokeWidth={2.2} />
    </a>
    <button data-testid="nav-cta-button" onClick={() => go("contact")} className="rounded-full bg-navy px-5 py-2 text-sm font-semibold text-white transition-all hover:bg-navy-light hover:shadow-lg hover:shadow-gold/25">
      Devis gratuit
    </button>
  </div>
);

const MobileMenu = ({ go }) => (
  <div className="border-t border-navy/10 bg-cream px-6 py-4 md:hidden">
    {NAV_LINKS.map((l) => (
      <button key={l.id} data-testid={`nav-mobile-link-${l.id}`} onClick={() => go(l.id)} className="block w-full border-b border-navy/5 py-3 text-left text-base font-semibold text-navy">
        {l.label}
      </button>
    ))}
    <a href="tel:+33784678802" className="flex items-center gap-2 py-4 font-semibold text-navy" data-testid="nav-mobile-phone-link">
      <Phone size={16} /> 07 84 67 88 02
    </a>
    <a href="/admin" className="flex items-center gap-2 border-t border-navy/5 py-3 text-sm font-semibold text-slate-600" data-testid="nav-mobile-admin-link">
      <Lock size={14} /> Espace pro
    </a>
  </div>
);

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <header className="fixed inset-x-0 top-0 z-50 border-b border-navy/10 bg-cream/80 backdrop-blur-xl">
      <nav className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6 lg:px-8">
        <button data-testid="nav-logo" onClick={() => go("hero")} aria-label="site.com — retour en haut">
          <Logo />
        </button>
        <div className="hidden items-center gap-8 md:flex">
          {NAV_LINKS.map((l) => (
            <button key={l.id} data-testid={`nav-link-${l.id}`} onClick={() => go(l.id)} className="text-sm font-semibold text-slate-600 transition-colors hover:text-navy">
              {l.label}
            </button>
          ))}
        </div>
        <DesktopActions go={go} />
        <button data-testid="nav-mobile-toggle" className="rounded-full border border-navy/15 p-2 text-navy md:hidden" onClick={() => setOpen(!open)} aria-label="Menu">
          {open ? <X size={20} /> : <Menu size={20} />}
        </button>
      </nav>
      {open && <MobileMenu go={go} />}
    </header>
  );
};
